import { VsGraphQLError } from '@vs/rtk/utils';
import { useTranslation } from 'react-i18next';

import { Row } from '../type';
import { CodeBlock } from './CodeBlock';
import InfoBlock from './InfoBlock';

type PropsVsGraphQLErrorInfo = {
  sentryId?: string;
  errorObj: VsGraphQLError;
  showFullErrMsg?: boolean;
};

export default function VsGraphQLErrorInfo({
  sentryId,
  errorObj,
  showFullErrMsg = false,
}: PropsVsGraphQLErrorInfo) {
  const { t } = useTranslation();

  const rows = [
    {
      label: t('shared:dialog.unexpected_err.label.status_code', {
        defaultValue: `Status code`,
      }),
      value: errorObj.status,
      hide: !showFullErrMsg,
    },
  ] satisfies Row[];
  return (
    <>
      <CodeBlock className="mb-4">
        {`${t('shared:dialog.unexpected_err.label.log_id', {
          defaultValue: `Log ID`,
        })}: ${sentryId}`}
      </CodeBlock>
      <InfoBlock
        rows={rows.filter(r => !r.hide)}
        additionalMessage={
          !showFullErrMsg ? undefined : JSON.stringify(errorObj.cause, null, 2)
        }
      />
    </>
  );
}
